import {
  ScreenerSettingName,
  useIsScreenerSettingEnabledForAnyFacility
} from '@/hooks/screener-settings';
import { useCurrentUser } from '@/hooks/useCurrentUser';
import { ExacareFeature, FeatureFlagService } from '@/utils/featureFlagService';

type DataCenterVersion = 'v2' | 'v3';

export const useDataCenterVersion = ():
  | DataCenterVersion
  | 'loading'
  | null => {
  const currentUser = useCurrentUser().data;
  const isV3Enabled = useIsScreenerSettingEnabledForAnyFacility(
    ScreenerSettingName.DataCenterV3
  );

  if (
    !FeatureFlagService.isEnabled(ExacareFeature.DATA_CENTER_TAB) ||
    !currentUser?.isDataCenterEnabled()
  ) {
    return null;
  }

  if (isV3Enabled === undefined) {
    return 'loading';
  }
  return isV3Enabled ? 'v3' : 'v2';
};
